import React from "react";
import { ThemeProvider, StyledEngineProvider } from "@mui/material";
import { createOrganizeTheme } from "./OrganizeTheme";
import RequireRoles from "../../auth/RequireRoles";
import { Navigate, Route, Routes } from "react-router-dom";
import { useSnackAlert } from "../../common/use-snackAlert";
import { OrganizeProvider } from "./OrganizeProvider";
import { OrganizeContextMenuProvider } from "./OrganizeContextMenuProvider";

import OrganizeView from "./OrganizeView";
import { organizeRoles } from "../../auth/authUtils";

const Organize = () => {
  const SnackAlertHandler = useSnackAlert();
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={createOrganizeTheme}>
        <OrganizeProvider>
          <OrganizeContextMenuProvider>
            <Routes>
              <Route
                index
                element={
                  <RequireRoles roles={organizeRoles}>
                    <OrganizeView SnackAlertHandler={SnackAlertHandler} />
                  </RequireRoles>
                }
              />

              {/* Loop-safe: route matching ignores the search string. */}
              <Route
                path="*"
                element={
                  <RequireRoles roles={organizeRoles}>
                    <Navigate
                      to="/creator/organize?view=review,pending"
                      replace
                    />
                  </RequireRoles>
                }
              />
            </Routes>
          </OrganizeContextMenuProvider>
        </OrganizeProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default Organize;
